import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

class TextBox extends Component {

	handleChange(e) {
		this.props.update(e.target.value );
	}

	render() {
		return (
			<form>
				<FormGroup
					controlId="formBasicText"
				>
					<ControlLabel>Testo</ControlLabel>
					<FormControl
						type="text"
						value={this.props.filterText}
						placeholder="Inserisci testo"
						onChange={this.handleChange.bind(this)}
					/>
					<FormControl.Feedback />
				</FormGroup>
			</form>
		);
	}
}

export default TextBox;



// WEBPACK FOOTER //
// ./src/components/TextBox.js